/* Core & libraries */
import React from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from '../../ucmodal';
import { ReactComponent as PromoLogo } from '../../../resources/images/building.svg';

/* Styles */
import styles from './styles';

const InvalidPromoCodesModal = ({ showPromoCodesModal, setShowPromoCodesModal, codes = '', onExited }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.promoCodesModal}
      customStyle={classes.promoCodesModalWrapper}
      backdropClassName={classes.promoCodesBackdrop}
      showModal={showPromoCodesModal}
      setShowModal={setShowPromoCodesModal}
      onExited={onExited}
      modalIcon={<PromoLogo />}
      modalTitle={<FormattedMessage id="invalidPromoCodesModal.title" />}
      modalDescription={
        <div className={classes.modalDescription}>
          <FormattedMessage id="invalidPromoCodesModal.description" values={{ promoCodes: codes }} />
        </div>
      }
    />
  );
};

export default InvalidPromoCodesModal;